/**
 * ProjectCreatePage Component
 * Page for creating new projects and templates
 * Phase 7 Batch 7.3 - Proposal Frontend
 */
import { useSearchParams } from 'react-router-dom';
import { DashboardLayout } from '@/components/layout/DashboardLayout.tsx';
import { ProjectForm } from '@/components/ProjectForm';

export function ProjectCreatePage() {
  const [searchParams] = useSearchParams();

  // Check if creating a template
  const isTemplate = searchParams.get('isTemplate') === 'true';

  return (
    <DashboardLayout title={isTemplate ? 'New Template' : 'New Project'}>
      <div className="max-w-2xl">
        <ProjectForm mode="create" isTemplate={isTemplate} />
      </div>
    </DashboardLayout>
  );
}
